import carGif from "icons/car/gray_car.gif"
import carImg from "icons/car/gray_car.jpg"

export default {
  img: carImg,
  gif: carGif,
}
